export const storeData = {
  StoreInformation: "StoreInformation",
  projectName: "集运系统", // 默认系统名称
};
